import { render } from "./mini-calendar-event.vue?vue&type=template&id=51676637"
import script from "./mini-calendar-event.vue?vue&type=script&lang=js"
export * from "./mini-calendar-event.vue?vue&type=script&lang=js"

import "./mini-calendar-event.vue?vue&type=style&index=0&id=51676637&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__